import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import AsyncSelect from 'react-select/async';
import AsyncCreatableSelect from 'react-select/async-creatable';
import { titleCaseIfExists, urlSlugify } from 'utils/helper';
import { api } from '../../utils/axios';
import { GET_USER_ROLE } from 'utils/constants';
import { useRouter } from 'hooks/useRouter';
import AuthService from 'common/auth.service';

const SmkAsyncSelect = (props) => {
  const { isClearable = true, isValueSlugify = false, apiMethod = 'POST', isDoctor = false } = props;
  const indicatorSeparatorStyle = {
    alignSelf: 'stretch',
    backgroundColor: 'transparent',
    marginBottom: 8,
    marginTop: 8,
    width: 1,
  };
  const [inputValue, setInputValue] = useState('');
  const router = useRouter();

  const authService = new AuthService();
  const token = authService.getSessionCookie();

  const promiseOptions = (inputValue) => {
    if (inputValue.length > 2) {
      return new Promise((resolve) => {
        api(
          {
            method: apiMethod,
            url: props.fetchUrl + (props?.isQueryParam ? `?${props.searchKeyName}=${inputValue}` : ''),
            data: {
              [props.searchKeyName]: isValueSlugify ? urlSlugify(inputValue) : inputValue,
              ...props.filters,
            },
          },
          {
            ...(props?.isHealthcare
              ? {
                  'x-api-key': process.env.REACT_APP_HEALTHCARE_API_KEY,
                  Authorization: `Bearer ${token}`,
                }
              : {}),
          }
        ).then((response) => {
          const { data } = response;
          let results = response?.results?.filter((e) => e?.id !== router?.query?.id);
          let formatData;

          if (props?.isTaxonomyCategory) {
            results = response?.results?.filter((e) => e?.type?.startsWith('nutrition_'));
          }

          if (isEmpty(data)) {
            if (isDoctor) {
              formatData = results?.map((instance) => ({
                ...instance,
                label: `${instance?.firstName} ${instance?.lastName} - ${instance?.areaOfExpertise}`,
                value: instance?.id,
              }));
            } else {
              formatData = results?.map((instance) => {
                const combine_label = !isEmpty(props?.combineLabelKey)
                  ? props?.combineLabelKey === 'role'
                    ? `${instance[props?.acceptedKey]} - ${titleCaseIfExists(
                        GET_USER_ROLE[instance[props?.combineLabelKey]]
                      )}`
                    : instance[props?.combineLabelKey] + ' - ' + instance[props?.acceptedKey]
                  : '';

                return {
                  ...instance,
                  label: !isEmpty(combine_label)
                    ? combine_label
                    : !isEmpty(props?.acceptedKey)
                    ? instance[props?.acceptedKey]
                    : instance?.name,
                  value: !isEmpty(props?.acceptedValue) ? instance[props?.acceptedValue] : instance?.name,
                };
              });
            }
          } else {
            formatData = data?.results?.map((instance) => ({
              ...instance,
              label: instance.name,
              value: instance.name,
            }));
          }

          setTimeout(() => {
            resolve(formatData);
          }, 1000);
        });
      });
    } else {
      return Promise.resolve([]);
    }
  };

  const handleChange = (newValue) => {
    if (props.onChange) {
      props.onChange(newValue);
    }
  };

  const handleInputChange = (newValue) => {
    setInputValue(newValue);
    return newValue;
  };

  const IndicatorSeparator = ({ innerProps }) => {
    return <span style={indicatorSeparatorStyle} {...innerProps} />;
  };

  const handleBlur = () => {
    if (props.onBlur) {
      props.onBlur(props.id, true);
    }
  };

  return (
    <>
      {props.creatable && (
        <AsyncCreatableSelect
          components={{ DropdownIndicator: null, IndicatorSeparator }}
          inputValue={inputValue}
          isClearable={isClearable}
          isMulti={props.multi}
          onChange={handleChange}
          onBlur={handleBlur}
          onInputChange={handleInputChange}
          loadOptions={promiseOptions}
          placeholder={props.placeholder}
          value={props.value}
          noOptionsMessage={() => null}
          menuPlacement="top"
        />
      )}
      {!props.creatable && (
        <AsyncSelect
          id={props.id}
          isMulti={props.multi}
          components={{ DropdownIndicator: null, IndicatorSeparator }}
          isClearable={isClearable}
          onChange={handleChange}
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              border: '1px solid #ced4da',
            }),
            menu: (provided) => ({ ...provided, zIndex: 9999 }),
          }}
          onBlur={handleBlur}
          loadOptions={promiseOptions}
          placeholder={props.placeholder}
          isDisabled={props.isDisabled}
          noOptionsMessage={() => null}
          value={props.value || null}
        />
      )}
    </>
  );
};

SmkAsyncSelect.propTypes = {
  id: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.array,
  // options: PropTypes.object, // not being used
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  small: PropTypes.bool,
  bordered: PropTypes.bool,
  multi: PropTypes.bool,
  isDisabled: PropTypes.func,
  creatable: PropTypes.bool,
  fetchUrl: PropTypes.string,
  filters: PropTypes.object,
  searchKeyName: PropTypes.string,
};

export default SmkAsyncSelect;
